// extracted by mini-css-extract-plugin
module.exports = {"statusDot":"package-status-dot_style_statusDot__-QcZv"};